export const RUBBLE_MOUND = 'RUBBLE_MOUND'
export const GABION = 'GABION'
export const CONCRETE_ELEMENT = 'CONCRETE_ELEMENT'
export const FILTER_NET = 'FILTER_NET'

export type MaterialType =
  | typeof RUBBLE_MOUND
  | typeof GABION
  | typeof CONCRETE_ELEMENT
  | typeof FILTER_NET

export const BLOCKMAT = 'BLOCKMAT'
export const CONCRETE_BLOCK = 'CONCRETE_BLOCK'
export const ASPHALTMATT = 'ASPHALTMATT'
export const INSITU_FILLED_MATTRESS_PROSERVE = 'INSITU_FILLED_MATTRESS_PROSERVE'

export type ConcreteElementType =
  | typeof BLOCKMAT
  | typeof CONCRETE_BLOCK
  | typeof ASPHALTMATT
  | typeof INSITU_FILLED_MATTRESS_PROSERVE

export type Material = {
  id: number
  project: number | null
  calculation: number | null
  material_type: MaterialType[]
  water_density?: number
  angle_repose_subsoil?: number

  standard_rock_grading?: string[]
  custom_rock_grading?: number[]
  rubble_mound_rock_density?: number
  rubble_mound_angle_repose_rock?: number
  layer_thickness_coefficient?: number

  gabion_rock_density?: number
  gabion_rock_porosity?: number
  gabion_angle_repose_rock?: number
  angle_repose_gabion?: number

  concrete_element_type?: ConcreteElementType[]
  concrete_density?: number
  angle_repose_concrete?: number

  filter_net_type?: string[]
  filter_net_rock_density?: number
}
